import type { ExtendedOrganization } from '#src/models/organizations/ExtendedOrganization.ts'
import type { NetworkContract } from '#src/models/practitioner.ts'

// A practitioner's contract is derived from the organizations they hold a role
// at: Astrana wins when they span both kinds, and undefined means none of the
// organizations records one — distinct from a deliberate Direct.
export function contractFromOrganizations(
  organizations: ExtendedOrganization[]
): NetworkContract | undefined {
  let contract: NetworkContract | undefined
  for (const organization of organizations) {
    if (organization.networkContract === 'Astrana') {
      return 'Astrana'
    }
    if (organization.networkContract === 'Direct') {
      contract = 'Direct'
    }
  }
  return contract
}
